module.exports = __webpack_public_path__ + "static/media/breadCrumbArrow.d7d2a13b.svg";